import Currency from './Currency.js'

export default new Proxy(
    new (class {
        system = undefined;
        Currency = undefined;

        setSystem(system) {
            this.system = system
            this.Currency = Currency
                .setLocale(system.locale)
                .setCurrency(system.currency)

            return this
        }


        /* If you're adding more methods to this class, which I'm hoping doesn't happen, speak to Mark and we can figure out a cleaner way to add these. */
        domainUrl(path) {
            if (! path.startsWith('/')) {
                path = `/${ path }`;
            }
            return `https://${ this.system.liquidline_domain }${ path }`
        }
    }), {
        get: (target, prop, receiver) => (! target.hasOwnProperty(prop) && ! Object.getPrototypeOf(target).hasOwnProperty(prop))
            ? target['system'][prop]
            : target[prop],
        apply: (target, prop, args) => target.apply(prop, args)
    }
)
